module.exports = __webpack_public_path__ + "static/rework-5814bbb0a5e19af4e0e31840acabd44e.jpg";